import { render, staticRenderFns } from "./DestinationSelector.vue?vue&type=template&id=bbc06d06&"
import script from "./DestinationSelector.vue?vue&type=script&lang=js&"
export * from "./DestinationSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports